import { Box, SelectChangeEvent, Stack, useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';

import classNames from 'classnames/bind';
import styles from './Step1.scss';
import ToastUtil from '@/views/components/Toast/Toast';
import { getDataInfoMF } from '@/controllers/gridManager/followerTransManager/followerTransManager';
import { doInit2factorAuth, useAccounts, useUserInfo } from '@/controllers/gridManager/accountsManager/accountManager';
import { DataOnParents, KeyDataParents } from './RegisterFollower';
import { isEmpty } from 'lodash';
import ButtonElement from '@/views/elements/button/ButtonElement';
import CheckboxElement from '@/views/elements/checkBox/CheckBox';
import { useTranslation } from 'react-i18next';
import AccountSelector from '@/views/components/componentsUI/AccountSelector';
import ViewNumberFormat from '@/views/elements/Inputs/ViewNumberFormat';
import TypographyElement from '@/views/elements/typography/TypographyElement';
import { setStateLoadingAction, setStatusRegisterMFAction } from '@/stores/dataManager/Actions/appAction';
const cx = classNames.bind(styles);

export type PropsStep = {
    close: () => void,
    back: () => void,
    next: () => void,
    handleSaveDataOnParents: (key: KeyDataParents, data: {}) => void
    dataOnParents: DataOnParents
}

const Step1 = ({ close, back, next, handleSaveDataOnParents, dataOnParents }: PropsStep) => {
    const { t } = useTranslation()
    const theme = useTheme()

    const { accounts } = useAccounts()
    const { userInfo } = useUserInfo()
    const { custodycd } = userInfo
    const { Step1 }: { Step1: any } = dataOnParents
    const [agree, setAgree] = useState<boolean>(false)
    const [asset, setAsset] = useState<number | string>('')
    const [currentAccountId, setCurrentAccountId] = useState<any>(accounts?.[0]?.acctno ?? '')

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setAgree(event.target.checked);
    };

    useEffect(() => {
        if (!isEmpty(Step1)) {
            setAgree(Step1.agree)
        }
        handleSaveDataOnParents("dataVerify", {});
    }, [])

    useEffect(() => {
        async function callApiInfo() {
            const { isSuccess, data } = await getDataInfoMF(currentAccountId)
            if (isSuccess) {
                const { baldefovd } = data
                setAsset(baldefovd)
            }
        }

        callApiInfo()
    }, [currentAccountId])

    const handleChangeAccount = (event: SelectChangeEvent) => {
        setCurrentAccountId(event.target.value);
    };

    const validCheckBox = () => {
        if (agree === true) return true
        return false;
    }

    const handleNext = async () => {
        if (validCheckBox() === false) {
            ToastUtil.error(t("copytrade.registerFollower.warnPolicy"))
            return
        }

        setStatusRegisterMFAction(null)

        setStateLoadingAction(true)
        const { isSuccess, data } = await doInit2factorAuth()
        setStateLoadingAction(false)
        if (isSuccess && Object.hasOwn(data, 'transactionId')) {
            handleSaveDataOnParents("Step1", { agree, custodycd, currentAccountId });
            handleSaveDataOnParents("dataVerify", data);
            next()
        }
    }

    const handleBack = () => {
        back()
    }

    return (
        <Box className="Step1">
            <Stack
                direction={"column"}
                spacing={2}
            >
                <Stack
                    direction={"column"}
                    spacing={2}
                >
                    <div className="label-custodycd">
                        {/* {t('header.welcome')} */}
                        <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement='primary'>
                            {t("copytrade.registerFollower.linkAccount")} <span className={cx('text-req')}>*</span>
                        </TypographyElement>
                    </div>
                    <AccountSelector
                        currentAccountId={currentAccountId}
                        handleChangeAccount={handleChangeAccount}
                    />

                </Stack>

                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                >
                    <Box>
                        <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement='secondary'>
                            {t("copytrade.registerFollower.account")}
                        </TypographyElement>
                    </Box>
                    <Box>
                        {custodycd}
                    </Box>
                </Stack>

                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                >
                    <Box>
                        <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement='secondary'>
                            {t("copytrade.registerFollower.availableBalance")}
                        </TypographyElement>
                    </Box>
                    <Box>
                        <ViewNumberFormat align='end' value={asset} />
                    </Box>
                </Stack>

                <Stack
                    direction={"row"}
                    justifyContent={"space-between"}
                    sx={{
                        border: "1px solid",
                        borderColor: theme.palette.border,
                        py: "10px",
                        borderRadius: '4px'
                    }}
                >
                    <CheckboxElement checked={agree} onChange={handleChange}
                        inputProps={{ 'aria-label': 'controlled' }} />
                    <Box>
                        <TypographyElement FontSizeElement='14px' FontWeightElement={400} ColorElement="primary">{t("copytrade.registerFollower.policy1")}
                            <TypographyElement sx={{
                                cursor: 'pointer'
                            }}
                                component={'span'} FontSizeElement='14px' FontWeightElement={400} ColorElement="brand">{t("copytrade.registerFollower.policy2")}</TypographyElement>
                            {t("copytrade.registerFollower.policy3")}<TypographyElement sx={{
                                cursor: 'pointer'
                            }}
                                component={'span'} FontSizeElement='14px' FontWeightElement={400} ColorElement="brand">{t("copytrade.registerFollower.policy4")}</TypographyElement></TypographyElement>
                    </Box>
                </Stack>

                <Stack
                    direction={"row"}
                    spacing={2}
                    justifyContent={"center"}
                >
                    <ButtonElement customType='Secondary' className={cx("btn-register")} variant="contained"
                        onClick={() => close()} >{t("copytrade.common.close")}</ButtonElement>
                    <ButtonElement disabled={!agree} customType='Primary' className={cx("btn-register")} variant="contained"
                        onClick={
                            () => handleNext()
                        } >{t("copytrade.common.next")}</ButtonElement>
                </Stack>
            </Stack>
        </Box >
    )
}

export default Step1